import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M21.06 19.452H.94a.956.956 0 0 1-.817-.465.968.968 0 0 1 0-.943L10.183.439a.981.981 0 0 1 1.634 0l10.06 17.605a.968.968 0 0 1 0 .943.956.956 0 0 1-.817.465Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M11 12.536a.955.955 0 0 1-.943-.943V7.192a.943.943 0 0 1 1.886 0v4.4a.955.955 0 0 1-.943.944ZM11 16.308a.955.955 0 0 1-.943-.943v-.629a.943.943 0 1 1 1.886 0v.63a.955.955 0 0 1-.943.942Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }